if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      membershipInCart = () =>
        window.Allstora.cart.items.some((item) => {
          return (
            item.variant_id === window.Allstora.membership.variant_id ||
            item.variant_id === window.Allstora.membership_yearly.variant_id ||
            item.variant_id === window.Allstora.digital_membership_yearly.variant_id
          );
        });

      constructor() {
        super();

        this.form = this.querySelector('form');

        const inputId = this.form.querySelector('[name=id]');
        if (inputId) {
          inputId.disabled = false;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.addWithMembershipButton = document.querySelector('button[name="addMembership"]');
        if (this.addWithMembershipButton) {
          this.addWithMembershipButton.addEventListener('click', this.handleAddMembership.bind(this));
        }
      }

      async handleAddMembership(evt) {
        evt.preventDefault();
        await this.addMembership();
        this.onSubmitHandler(evt, this.addWithMembershipButton, '.membership-loading__spinner');
      }

      async addMembership() {
        if (this.membershipInCart()) {
          console.log('membership in cart');
          return;
        }

        const formData = new FormData();
        const type = this.addWithMembershipButton.dataset.membershipType;
        if (type === 'digital') {
          formData.append('id', window.Allstora.digital_membership_yearly.variant_id);
          formData.append('selling_plan', window.Allstora.digital_membership_yearly.selling_plan_id);
        } else {
          formData.append('id', window.Allstora.membership_yearly.variant_id);
          formData.append('selling_plan', window.Allstora.membership_yearly.selling_plan_id);
        }

        formData.append('quantity', 1);
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        try {
          const res = await fetch(`${routes.cart_add_url}`, config);
          const data = await res.json();
          if (data.status) {
            console.error(data.message);
          }
        } catch (e) {
          console.error(e);
        }
      }

      onSubmitHandler(evt, button = this.submitButton, spinnerClass = '.product-loading__spinner') {
        evt.preventDefault();
        if (button.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');
        this.querySelector(spinnerClass)?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const formDataValues = [...formData.values()];

        let isMembershipProduct = false;

        formDataValues.forEach((val) => {
          isMembershipProduct =
            isMembershipProduct ||
            (window.Allstora.membership.variant_id && val === window.Allstora.membership.variant_id.toString()) ||
            (window.Allstora.membership_yearly.variant_id &&
              val === window.Allstora.membership_yearly.variant_id.toString());
        });

        if (isMembershipProduct && this.membershipInCart()) {
          alert('Membership is already in your cart.');
          button.setAttribute('aria-disabled', false);
          button.classList.remove('loading');
          this.querySelector(spinnerClass)?.classList.add('hidden');
          return;
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              button.setAttribute('aria-disabled', true);
              button.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) button.removeAttribute('aria-disabled');
            this.querySelector(spinnerClass)?.classList.add('hidden');

            // Membership auto-add is retired with the new-member offer (its script is no longer
            // loaded in theme.liquid). Dedupe still removes a membership when a book club is in the cart.
            if (typeof window.MembershipAutoDedupe === 'function') window.MembershipAutoDedupe();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
